import { render } from "./answer.vue?vue&type=template&id=12fa2f92&scoped=true"
import script from "./answer.vue?vue&type=script&lang=js"
export * from "./answer.vue?vue&type=script&lang=js"

import "./answer.vue?vue&type=style&index=0&id=12fa2f92&lang=scss&scoped=true"
import "./answer.vue?vue&type=style&index=1&id=12fa2f92&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12fa2f92"]])

export default __exports__